// extracted by mini-css-extract-plugin
export default {"section":"Products_section__Iz3m0","navigation":"Products_navigation__7+bBS","home":"Products_home__wEOXR","list":"Products_list__V+3fI","cars":"Products_cars__BX2P8"};